import { useAppSelector } from '../../../types';
import { selectedRoadSectionIdsQuery } from '../../../core/reference/queries';
import { Stack, Box } from '@mui/material';
import DispatchButton from '../../design_system/inputs/buttons/DispatchButton';

export const ActionsOnSelectedRoadSections = () => {
    const selectedIds = useAppSelector(selectedRoadSectionIdsQuery);

    return (
        <Stack sx={{ flexDirection: 'row', justifyContent: 'flex-end', m: 1.5 }}>
            {selectedIds.length > 0 ? (
                <Stack direction="row" gap={1}>
                    <DispatchButton title="reference.edit_gestionary" modalType="ROAD_SECTION_EDIT_GESTIONARY" />
                    <DispatchButton title="reference.edit_category" modalType="ROAD_SECTION_EDIT_CATEGORY" />
                    <DispatchButton title="reference.edit_traficPL" modalType="ROAD_SECTION_EDIT_TRAFIC_PL" />
                    <DispatchButton title="reference.edit_urban" modalType="ROAD_SECTION_EDIT_URBAN" />
                    <DispatchButton title="reference.edit_roadType" modalType="ROAD_SECTION_EDIT_ROAD_TYPE" />
                    <DispatchButton title="reference.edit_width" modalType="ROAD_SECTION_EDIT_WIDTH" />
                    <DispatchButton title="reference.edit_year" modalType="ROAD_SECTION_EDIT_YEAR" />
                </Stack>
            ) : (
                <Box sx={{ height: 40 }} />
            )}
        </Stack>
    );
};
